import './Layout.css';
import './Button.css';
import { Outlet, Link } from "react-router-dom";

const Layout = () => {
  return (
    <>
    <div className ="Layout">
    
    <Link to="/">
    <button class="button">
    Home
    </button>
    </Link>

    
    </div>
    <Outlet />

    </>
  )
};

export default Layout;
